import {ExperienceLevel, Skill, StyledBaseProps} from "@betrue/shared/interfaces";
import styled from "styled-components";
import * as React from "react";
import {TaskCardProps} from "./task-card";
import {
  Avatar,
  Badge,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Chip,
  Collapse,
  Grid,
  IconButton,
  Link,
  Typography
} from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TimelineConnector from '@mui/lab/TimelineConnector';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import LaptopMacIcon from '@mui/icons-material/LaptopMac';
import HotelIcon from '@mui/icons-material/Hotel';
import RepeatIcon from '@mui/icons-material/Repeat';
import {
  AvatarGroup,
  Timeline,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator
} from "@mui/lab";
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import {DATASET, randomData} from "@betrue/shared/dataset";
import {SkillTag} from "@betrue/ui";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import {withStyles} from 'tss-react/mui';

const StyledBadge = withStyles(Badge,(theme) => ({
  root: {
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}));

interface TaskCardViewProps extends StyledBaseProps, TaskCardProps {

}

const skills = [
  {
    level: ExperienceLevel.INTERMEDIATE,
    onAdd: undefined,
    skill: randomData<Skill>(DATASET.skills, 1)[0]

  }, {
    level: ExperienceLevel.INTERMEDIATE,
    onAdd: undefined,
    skill: randomData<Skill>(DATASET.skills, 1)[0]

  }, {
    level: ExperienceLevel.INTERMEDIATE,
    onAdd: undefined,
    skill: randomData<Skill>(DATASET.skills, 1)[0]

  }, {
    level: ExperienceLevel.INTERMEDIATE,
    onAdd: undefined,
    skill: randomData<Skill>(DATASET.skills, 1)[0]

  }]

export const TaskCardView = styled((props: TaskCardViewProps) => {
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  return (
    <div className={props.className}>
      <Card>
        <CardHeader
          avatar={
            <Avatar aria-label="recipe"
                    src="https://portal.betrue.fr/graphql-api/files/avatar/81b96bbd-937f-4ad3-96f1-7bf5df845ad6?v=36"/>
          }
          action={
            <IconButton aria-label="settings">
              <MoreVertIcon/>
            </IconButton>
          }
          title={<div><Link title="BT21278" style={{fontWeight: "bold"}} href="#">BT21278</Link> COMMUNITY" +
            " MANAGEMENT (LINKEDIN) <Link title="V0" style={{fontWeight: "bold"}} color={"textSecondary"}
                                          href="#">V2</Link></div>}
          subheader={<Link title="Arpège / Centre de conférences VERSO" href="#">Arpège / Centre de conférences
            VERSO</Link>}
        />
        <CardMedia
          image="/static/images/cards/paella.jpg"
          title="Paella dish"
        />
        <CardContent>
          <Grid container direction={"row"} spacing={0}>
            {skills.slice(0, 10).map((profileSkill) => (
              <Grid item className='skill-item'>
                <SkillTag skill={profileSkill.skill}/>
              </Grid>
            ))}
          </Grid>
        </CardContent>
        <CardActions disableSpacing>
          <IconButton aria-label="add to favorites">
            <StyledBadge
              overlap="circular"
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              variant="dot"
            >
              <Avatar alt="Remy Sharp"
                      src="https://portal.betrue.fr/graphql-api/files/avatar/b8b27d70-d7ed-42b5-bfb1-29abe043fa99?v=27"/>
            </StyledBadge>
          </IconButton>
          <IconButton aria-label="add to favorites">
            <Badge color="primary" badgeContent={3}>
              <AccessTimeIcon/>
            </Badge>
          </IconButton>
          <IconButton aria-label="add to favorites">
            <Badge color="default" badgeContent={3}>
              <LocalAtmIcon/>
            </Badge>
          </IconButton>
          <IconButton aria-label="add to favorites">

            <Chip label="3" variant="outlined"/>
          </IconButton>
          <IconButton aria-label="add to favorites">
            <AvatarGroup max={4}>
              <Avatar alt="Remy Sharp"
                      src="https://portal.betrue.fr/graphql-api/files/avatar/ae4fe899-5c5b-4cef-9d7d-3d734fe7d78b?v=123"/>
              <Avatar alt="Travis Howard"
                      src="https://portal.betrue.fr/graphql-api/files/avatar/b61ff8ca-eebc-49f4-bbba-a26dd19ebb3c?v=12"/>
              <Avatar alt="Cindy Baker"
                      src="https://portal.betrue.fr/graphql-api/files/avatar/560ff9e1-d132-4a35-81a5-6597bbb5946f?v=20"/>
              <Avatar alt="Agnes Walker" src="/static/images/avatar/4.jpg"/>
              <Avatar alt="Trevor Henderson" src="/static/images/avatar/5.jpg"/>
            </AvatarGroup>
          </IconButton>

          <IconButton
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
          >
            <ExpandMoreIcon/>
          </IconButton>
        </CardActions>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent>
            <Timeline>
              <TimelineItem>
                <TimelineOppositeContent>
                  <Typography variant="body2" color="textSecondary">
                    9:30 am
                  </Typography>
                </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineDot>
                    <FastfoodIcon />
                  </TimelineDot>
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent>
                    <Typography variant="h6" component="h1">
                      Eat
                    </Typography>
                    <Typography>Because you need strength</Typography>
                </TimelineContent>
              </TimelineItem>
              <TimelineItem>
                <TimelineOppositeContent>
                  <Typography variant="body2" color="textSecondary">
                    10:00 am
                  </Typography>
                </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineDot color="primary">
                    <LaptopMacIcon />
                  </TimelineDot>
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent>
                    <Typography variant="h6" component="h1">
                      Code
                    </Typography>
                    <Typography>Because it&apos;s awesome!</Typography>
                </TimelineContent>
              </TimelineItem>
              <TimelineItem>
                <TimelineSeparator>
                  <TimelineDot color="primary" variant="outlined">
                    <HotelIcon />
                  </TimelineDot>
                  <TimelineConnector  />
                </TimelineSeparator>
                <TimelineContent>
                    <Typography variant="h6" component="h1">
                      Sleep
                    </Typography>
                    <Typography>Because you need rest</Typography>
                </TimelineContent>
              </TimelineItem>
              <TimelineItem>
                <TimelineSeparator>
                  <TimelineDot color="secondary">
                    <RepeatIcon />
                  </TimelineDot>
                </TimelineSeparator>
                <TimelineContent>
                    <Typography variant="h6" component="h1">
                      Repeat
                    </Typography>
                    <Typography>Because this is the life you love!</Typography>
                </TimelineContent>
              </TimelineItem>
            </Timeline>
          </CardContent>
        </Collapse>
      </Card>

    </div>
  )
})`


`
